import * as Cookies from 'js-cookie';
import { environment } from '@environments/environment';

export class CookiesHelper {
	public static checkCookie(key: string) {
		return Cookies.get(key);
	}

	public static deleteCookie(key: string) {
		Cookies.remove(key);
	}

	public static set(key: string, value: string, expiration: Date) {
		const properties = {
			secure: true,
			expires: expiration
		};
		if (!environment.production) {
			properties.secure = false;
		}
		Cookies.set(key, value, properties);
	}

	public static deleteAll(namespace = '/') {
		const properties = {
			secure: true,
			path: namespace
		};
		if (!environment.production) {
			properties.secure = false;
		}
		Object.keys(Cookies.get()).forEach((cookieName) => {
			Cookies.remove(cookieName, properties);
		});
	}

	public static get(key: string) {
		return Cookies.get(key);
	}
}
